import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/store";
import AttendanceCardAndChart from "../../../components/Dashboard/AttendanceCardAndChart";
import EmployeeCards from "../../../components/Dashboard/EmployeeCards";
import ExpanseForDashboard from "../../../components/Dashboard/ExpanseForDashboard";
import LeaveCards from "../../../components/Dashboard/LeaveCards";
import { setShowModal } from "../../../features/auth/authSlice";
import { useGetPayrollSettingQuery } from "../../../features/payrollSetting/payrollSettingApi";
import useError from "../../../hooks/useError";
import useModal, { ModalType } from "../../../hooks/useModal";
import SidebarLayout from "../../../layouts/SidebarLayout";
import GrossConfiguredYetModal from "./GrossConfiguredYetModal";

export default function Dashboard() {
  const dispatch = useAppDispatch();
  const { showModalDashboard } = useAppSelector((state) => state.auth);
  const { open, handleClose, handleOpen } = useModal<string, ModalType>(
    reRender
  );
  const { data, isError, error } = useGetPayrollSettingQuery();

  useError(isError, error, "Gross salary configured data fail ");

  const isShowModal =
    data?.data?.payroll_setting?.pay_components?.pay_schedule?.is_enable;

  useEffect(() => {
    if (isShowModal && showModalDashboard) {
      handleOpen({ type: "VIEW" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowModal, showModalDashboard]);

  function reRender() {
    dispatch(setShowModal(false));
  }

  return (
    <SidebarLayout title="Dashboard">
      <div className="dashboard">
        <EmployeeCards />
        <LeaveCards />
        <AttendanceCardAndChart />
        <ExpanseForDashboard />
      </div>

      {open.type === "VIEW" && (
        <GrossConfiguredYetModal
          open={open.open}
          handleClose={() => handleClose(true)}
          loading={false}
        />
      )}
    </SidebarLayout>
  );
}
